import { useContext, useState } from 'react'

import { helpers, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { getOrderAmount } from '@/helpers'
import { hasEvaluationOptOut } from '@/helpers/evaluationOptOut/evaluationOptOut'
import * as seon from '@/helpers/seon/fingerprint'
import { getSeonStreamId } from '@/helpers/seon/stream'
import userEvents from '@/helpers/userEvents/userEvents'
import services from '@/services/services'

import { getCreateReturnPayload } from './helpers'

const useCreateReturn = () => {
  const { context, setContext } = useContext(AppContext)
  const [fetchingSeonSession, setFetchingSeonSession] = useState(false)
  const { fetchData: createReturnRequest, loading: creatingReturn } = useFetch(services.createReturn, {
    doInitialRequest: false,
  })

  const createReturn = async items => {
    const optsOutOfEvaluation = hasEvaluationOptOut()
    let seonBase64 = null
    let seonStreamId = null

    if (!optsOutOfEvaluation) {
      setFetchingSeonSession(true)
      seonBase64 = await seon.getSeonSession()
      setFetchingSeonSession(false)

      seonStreamId = getSeonStreamId()
    }

    const payload = getCreateReturnPayload({
      items: items || context.items,
      sessionId: userEvents.sessionId,
      seonBase64,
      joinGroup: context.orderInfo.joinGroup,
      giftRecipient: context.orderInfo.gift_recipient,
      returnPortalId: context.merchantInfo.returnPortalId,
      seonStreamId,
    })

    userEvents.sendEvents()

    const data = await createReturnRequest({ returnInfo: payload, orderId: context.orderInfo.id })
    setContext(context => ({ ...context, orderInfo: { ...context.orderInfo, returnId: data.id } }))

    setContext(context => ({
      ...context,
      displayMessages: data.display_messages || [],
      consentModal: data.consent_modal,
      summaryLineItems: helpers.joinLineItemsAndLineItemGroups(data.line_items, data.line_item_groups) || [],
      orderInfo: {
        ...data,
        ...context.orderInfo,
        returnId: data.id,
        refundType: null,
        is_instant_exchange_allowed: data.is_instant_exchange_allowed,
        allowed_refund_methods: data.allowed_refund_methods,
        issue_refund_at_status: data.issue_refund_at_status,
      },
      orderAmount: getOrderAmount(data),
    }))

    return data
  }

  return { createReturn, loading: fetchingSeonSession || creatingReturn }
}

export default useCreateReturn
